import React from 'react';
import { useTranslation } from 'react-i18next';
import errorimg from '../assets/img/colorkit (4).svg';

function ErrorPage({ error, pageName }) {
  const { t } = useTranslation('errorpage');

  const getErrorMessage = () => {
    if (error?.status === 500) {
      return {
        title: t('errorpage.warning_title', 'Warning'),
        message: t('errorpage.server_error_message', { pageName: pageName.toLowerCase() }),
        suggestion: t('errorpage.server_error_suggestion'),
      };
    }
    return {
      title: t('errorpage.warning_title', 'Warning'),
      message: t('errorpage.generic_error_message', { pageName: pageName.toLowerCase() }),
      suggestion: t('errorpage.generic_error_suggestion'),
    };
  };

  const { title, message, suggestion } = getErrorMessage();

  return (
    <div data-testid="error-page-container" className="h-full bg-white rounded-2xl shadow-lg p-4 sm:p-6 md:p-8 lg:p-10 flex items-center justify-center">
      <div data-testid="error-page-content" className="text-center max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-xl">
        <img
          data-testid="error-page-image"
          src={errorimg}
          alt={t('errorpage.error_illustration_alt')}
          className="mx-auto w-32 h-32 sm:w-40 sm:h-40 md:w-48 md:h-48 lg:w-56 lg:h-56 xl:w-64 xl:h-64 object-contain"
        />
        <h2 data-testid="error-page-title" className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold bg-gradient-to-r from-teal-600 to-cyan-600 bg-clip-text text-transparent mb-3 sm:mb-4">
          {title}
        </h2>
        <p data-testid="error-page-message" className="text-sm sm:text-base md:text-lg text-gray-800 mb-2 sm:mb-3 md:mb-4">
          {message}
        </p>
        <p data-testid="error-page-suggestion" className="text-xs sm:text-sm md:text-base text-gray-600 mb-4 sm:mb-6 md:mb-8">
          {suggestion}
        </p>
        <button
          data-testid="try-again-button"
          onClick={() => window.location.reload()}
          className="px-3 py-1.5 sm:px-4 sm:py-2 md:px-5 md:py-2.5 bg-[#4ABDBD] text-white font-semibold rounded-lg shadow-sm text-xs sm:text-sm md:text-base transition-all hover:bg-[#3aa8a8] focus:outline-none focus:ring-2 focus:ring-[#4ABDBD] focus:ring-opacity-50 cursor-pointer"
        >
          {t('errorpage.try_again_button')}
        </button>
      </div>
    </div>
  );
}

export default ErrorPage;